"use client";
import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoCheckmarkOutline } from "react-icons/io5";

export default function SearchDropdown({
  isOpen,
  header,
  value,
  onChange,
  onClose,
}) {
  const dropdownRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          ref={dropdownRef}
          initial={{ opacity: 0, y: -10, height: 0 }}
          animate={{ opacity: 1, y: 0, height: "auto" }}
          exit={{ opacity: 0, y: -10, height: 0 }}
          transition={{ duration: 0.25 }}
          className="absolute left-0 top-full w-full p-2 bg-[#D7EFFF] rounded-[3px] shadow-[0_4px_20px_0_rgba(0,_0,_0,_0.25)] overflow-hidden z-50"
        >
          <div className="p-2.5 border border-[#232633] bg-[#E4F4FF] rounded-[4px] shadow-[2px_2px_5px_0_rgba(0,_39,_81,_0.25)_inset] flex items-center justify-between gap-1.5">
            <input
              type="text"
              value={value || ""}
              onChange={(e) => onChange(e.target.value)}
              placeholder={`${header} 검색`}
              className="bg-transparent border-none outline-none text-[#242424] placeholder:text-[#ABB2CF] text-[14px] leading-[150%] flex-1 w-full"
            />
            <button>
              <IoCheckmarkOutline size={24} color="#242424" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
